import React ,{useContext } from 'react'
import d6 from './AccountInfo.module.css'
import {auth} from '../../../firebase'
import UserContext from '../../../store/UserContext.js'
import { Link } from 'react-router-dom';
function AccountInfo(props) {
 
let  userCtx=useContext(UserContext);
let userData=userCtx.user;
//console.log('date left ',userData.daysLeft)
    return (
        <div className={d6.InfoContainer}>
            
           
         <img  src={auth.currentUser.photoURL} alt='my profile' className={d6.image}/>  
          <div className={d6.data}> 
          <p>{auth.currentUser.displayName}</p>
          <p>{userData.grade} </p>
          <p> Valid till: {userData.expiry_date !== undefined ? userData.expiry_date.toDate().toString().substring(0,15):null}</p>
           { userData.daysLeft<= 5 && <p className={d6.renew}>{ userData.daysLeft>0 ?'Your Account will expire soon':"Your Account has expired"}</p>} 
          <p> Credits: {userData.credits}</p>
          
        { Boolean(userData.credits<=5 || userData.daysLeft<= 5) && <p onClick={ ()=>props.onClick()} ><Link to='/payments' className={d6.renew}> Renew subscription</Link></p>}
          </div>
         
        </div>
    )
}

export default AccountInfo
